import { render, staticRenderFns } from "./DetailStorageRequest.vue?vue&type=template&id=79b9a014&scoped=true"
import script from "./DetailStorageRequest.vue?vue&type=script&lang=js"
export * from "./DetailStorageRequest.vue?vue&type=script&lang=js"
import style0 from "./DetailStorageRequest.vue?vue&type=style&index=0&id=79b9a014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9a014",
  null
  
)

export default component.exports